<template>
  <div class="row scrollbar">
    <div class="col-lg-7 flex-center">
      <button class="btn-back" type="button" name="button" data-test="btnBack" @click="goBack">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>

      <h1 v-if="exam">{{ $t('user.exam') }} {{ formatDate(exam.date) }}</h1>

      <BaseTab 
        class="exam-tabs"
        :tabs="['images', 'attachments']" 
        :initialtab="activeTab" 
        @tab-activated="activeTab = $event"
      >
        <template v-slot:tab-head-images>
          {{ $t('images') }}
        </template>
        <template v-slot:images>
          <ExternalExamMediaTab v-if="activeTab === 'images'" />
        </template>

        <template v-slot:tab-head-attachments>
          {{ $t('attachments') }}
        </template>
        <template v-slot:attachments>
          <ExternalExamAttachmentsTab v-if="activeTab === 'attachments'" />
        </template>
      </BaseTab>

      <!-- YAMA temporary removal -->
      <button class="btn btn-success" type="button" name="button" @click.stop.prevent="doDownloadExam()"> {{ $t('externalPatient.downloadImages') }}</button>
    </div>
    <div class="col-lg-5 flex-center">
      <BaseInfiniteTable class="no-border" v-if="tableReport" :tabledata="tableReport">
        <template v-slot:column_content="{item}">
          <button class="btn btn-outline-secondary" type="button" name="button" :data-title="$t('tooltips.report')" :data-test="`btnExamDownload_${item.uuid}`"  @click.stop.prevent="downloadPDF(item)">
            <IconDownloadPatient/>
            <span class="ms-2"> {{ $t('tooltips.report') }}</span>
          </button>
        </template>
      </BaseInfiniteTable>
      <!--
      <button class="btn-icon btn-top" type="button" name="button" v-if="currentPage > 1 && tableReport.items.length > 20" @click="goTop">
        <IconArrowUp/>
      </button>
      -->
      <!-- <ExternalExamReportPreview v-if="examID" :exam_id="examID"/> -->

      <!-- TODO YAMANAKA: endpoint para baixar todos os laudos de uma vez, é possivel? ou removo esse trem? hahahaha -->
      <!-- YAMA temporary removal -->
      <button class="btn btn-success" type="button" name="button" @click.stop.prevent="downloadLatestPDF()">{{ $t('externalPatient.downloadLatestReports') }}</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row {
  // height:                       calc(100% - 70px);
  align-items:                    center; // flex-end
}

.col-lg-7,
.col-lg-5 {
  flex-direction:                 column;
  // width:                        70%;
  // max-width:                    340px;
  // padding-bottom:               2rem;
  // padding-top:                  1rem;
  h1 {
    color:                        var(--Brand-Primary, #1B294A);
    font-size:                    38px;
    font-weight:                  300;
    line-height:                  normal;
    margin:                       15px 0 40px;
  }
  > div:not(.exam-tabs) {
    width:                        100%;
    display:                      flex;
    flex-direction:               column;
    align-items:                  flex-start;
    gap:                          26px;
    max-height:                   440px;
    height:                       100%;
    overflow-y:                   auto;
    overflow-x:                   hidden;
    padding-right:                10px;
    margin-bottom:                26px;
  }

  .no-border {
    width:                        100%;
  }
}

.col-lg-7 {
  align-items:                    flex-start;
}

.exam-tabs {
  width:                          100%;
}

.btn {
  &.btn-success {
    // color:                        var(--Brand-Primary, #1B294A);
    font-size:                    var(--font-size-14);
    font-weight:                  700;
    line-height:                  normal;
    letter-spacing:               4.2px;
    text-transform:               uppercase;
    text-align:                   center;
    max-width:                    340px;
    width:                        100%;
    margin:                       0 auto;
    border:                       1px solid var(--Shades-30, #D8D8D8);
    background:                   var(--Brand-Secondary, #3CB391);
  }
}

.scrollbar {
  width:                          100%;
}

:deep(.inside-box) {
  width:                          100%;
}

@media (max-width: 991px) {
  .row {
    max-height:                   calc(100dvh - 135px);
    padding-top:                  40px;
    overflow-y:                   auto;
    align-items:                  flex-start;
  }

  .col-lg-7 {
    h1 {
      font-size:                  32px;
      margin-bottom:              26px;
    }
  }

  .col-lg-7,
  .col-lg-5 {
    width:                        100%;
    max-height:                   unset;
    padding-right:                0;

    > div {
      max-height:                 unset !important;
      height:                     auto !important;
      overflow-y:                 visible !important;
    }
  }

  :deep(.inside-box) {
    height:                       auto !important;
    overflow-y:                   visible !important;
  }

  .btn.btn-success {
    width:                        calc(100% - 10px);
  }
}
</style>

<script>
// import ExternalExamReportPreview from './ExternalExamReportPreview.vue'
import ExternalExamMediaTab from './ExternalExamMediaTab.vue';
import ExternalExamAttachmentsTab from './ExternalExamAttachmentsTab.vue';

export default {
  name: 'ExternalExamShow',
  components: {
    // ExternalExamReportPreview,
    ExternalExamMediaTab,
    ExternalExamAttachmentsTab
  },
  data: () => ({
    loading: null,
    alert: {
      message: null,
      class: null
    },
    examID: null,
    exam: null,
    tableReport: {
      items: [],
      total: 0,
      columns: []
    },
    patientId: null,
    patientName: null,
    activeTab: 'images',
  }),
  computed: {
    locale() {
      return (this.$i18n && this.$i18n.locale) || this.$utils.getCurrentLanguage()
    },
  },
  created() {
    const data = this.$utils.parseDataQuery(this.$route.query.data)
    this.examID = this.$route.params.examID
    this.patientId = data.patientId
    this.patientName = data.patient_name
  },
  mounted() {
    this.fetchData()
    this.fetchReportData()

    // TODO EC-360
    // retrieve exam details using this endpoint -> /api/v2/eyercloud/external/exam/get [param -> id: exam.id]
    // this endpoint will return the examDataList too
  },
  provide() {
    return {
      scrollToTop: (callback) => {
        this.scrollTopCallback = callback;
      }
    };
  },
  methods: {
    goTop() {
      if (this.scrollTopCallback) {
        this.scrollTopCallback();
      }

      this.$nextTick(() => {
        this.currentPage = 1

        this.fetchData()
      })
    },
    goBack() {
      this.$router.push({name: 'external-exam-list'})
    },
    async fetchData () {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$externalService.getExam({id: this.examID});
        this.exam = response.exam
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    async fetchReportData() {
      this.alert.message = null;

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$externalService.getReportList({id: this.examID});

        this.tableReport = {
          'items': response.result,
          'total': response.totalCount,
          'columns': [
            {name: this.$i18n.t('exam.date'), type: 'date', value: 'date', width: '40%'},
            // {key: 'name', name: this.$i18n.t('exam.diagnosticHypothesis'), type: 'string', value: this.$i18n.t('exam.diagnosticHypothesis'), width: '40%'},
            {name: this.$i18n.t('physician'), type: 'string', value: 'responsible.rawName', width: '50%'},
            {key: 'content', name: '', type: 'custom', value: 'actions', width: '10%'}
          ]
        };

        if (response.result.length === 0) {
          this.tableReport = {}
          // this.$message.popup(this, 'request_empty', 'operationWarning', 'warn')
          this.alert = this.$message.alert(this, 'request_empty', 'warning')
        }
        // this.generateUrlPDF(response.result[0].id)
      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }
    },
    async doDownloadExam(){
        let params = {
            id: this.examID,
            patientId: this.patientId,
            patientName: this.patientName,
            locale: this.locale
        }
        try{
            await this.$externalService.downloadExam(params)
        }catch (error){
          this.$message.popup(this, 'request_error', 'operationFail', 'error')
        }

    },
    downloadPDF(item) {
      try{
        this.$externalService.generateReport(item.id);
      }catch (error) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
    },
    downloadLatestPDF(){
      let latest = this.tableReport.items[0].id
      try{
        this.$externalService.generateReport(latest);
      }catch (error) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
    },
    formatDate(date) {
      return moment(date).format(this.$i18n.t('dateTimeFormat'))
    },
  },
  // unmounted() {
  //   this.tabActive = 'info'
  // }
}
</script>
